// extracted by mini-css-extract-plugin
export default {"wrapper":"PromoPreview_wrapper__JUUUG","frame":"PromoPreview_frame__dmocU"};